import { getMercoTrays, createMercoTray, updateMercoTray, deleteMercoTray } from '../../api/mercoTrays';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_MERCO_TRAYS_VALUE = 'CHANGE_MERCO_TRAYS_VALUE';
export const CHANGE_MODAL_MERCO_TRAYS_VALUE = 'CHANGE_MODAL_MERCO_TRAYS_VALUE';
export const CHANGE_MERCO_TRAYS_SEVERAL_VALUES = 'CHANGE_MERCO_TRAYS_SEVERAL_VALUES';
export const RESET_MERCO_TRAYS_STORE = 'RESET_MERCO_TRAYS_STORE';

export const GET_MERCO_TRAYS = 'GET_MERCO_TRAYS';
export const GET_MERCO_TRAYS_SUCCESS = 'GET_MERCO_TRAYS_SUCCESS';
export const GET_MERCO_TRAYS_ERROR = 'GET_MERCO_TRAYS_ERROR';

export const NEW_MERCO_TRAY = 'NEW_MERCO_TRAY';
export const NEW_MERCO_TRAY_SUCCESS = 'NEW_MERCO_TRAY_SUCCESS';
export const NEW_MERCO_TRAY_ERROR = 'NEW_MERCO_TRAY_ERROR';

export const UPDATE_MERCO_TRAY = 'UPDATE_MERCO_TRAY';
export const UPDATE_MERCO_TRAY_SUCCESS = 'UPDATE_MERCO_TRAY_SUCCESS';
export const UPDATE_MERCO_TRAY_ERROR = 'UPDATE_MERCO_TRAY_ERROR';

export const DELETE_MERCO_TRAY = 'DELETE_MERCO_TRAY';
export const DELETE_MERCO_TRAY_SUCCESS = 'DELETE_MERCO_TRAY_SUCCESS';
export const DELETE_MERCO_TRAY_ERROR = 'DELETE_MERCO_TRAY_ERROR';

export const getMercoTraysAction = (function () {
  let prevController;

  return (params, actions) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_MERCO_TRAYS });
      try {
        const response = await getMercoTrays(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          actions.onSuccess([...results.content]);
          dispatch({ type: GET_MERCO_TRAYS_SUCCESS, payload: results });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_MERCO_TRAYS_ERROR });
        }
      }
    };
  };
})();

export const createMercoTrayAction = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: NEW_MERCO_TRAY });
    try {
      const response = await createMercoTray(params);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: NEW_MERCO_TRAY_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: NEW_MERCO_TRAY_ERROR });
    }
  };
};

export const updateMercoTrayAction = (uuid, params, actions) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_MERCO_TRAY });
    try {
      const response = await updateMercoTray(uuid, params);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: UPDATE_MERCO_TRAY_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: UPDATE_MERCO_TRAY_ERROR });
    }
  };
};

export const deleteMercoTrayAction = (uuid, actions) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_MERCO_TRAY });
    try {
      const response = await deleteMercoTray(uuid);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: DELETE_MERCO_TRAY_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: DELETE_MERCO_TRAY_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_MERCO_TRAYS_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_MERCO_TRAYS_SEVERAL_VALUES,
  payload: value,
});

export const changeModalValue = (key, value) => ({
  type: CHANGE_MODAL_MERCO_TRAYS_VALUE,
  payload: {
    key,
    value,
  },
});

export const resetStore = () => ({
  type: RESET_MERCO_TRAYS_STORE,
});
